import moment from "moment";
import {
  capitalize,
  formatPhoneNumber,
  formatZipCode,
} from "../../../../utils/formatUtils";
import { FormField, UserData, NormalizedUserData } from "./interface"; // Import interfaces

export const formFieldsByStep: Record<string, FormField[]> = {
  Administrator: [
    { label: "First Name", type: "text", name: "firstName" },
    { label: "Last Name", type: "text", name: "lastName" },
    { label: "Address", type: "text", name: "address" },
    { label: "City", type: "text", name: "city" },
    { label: "State", type: "select", name: "state" },
    { label: "Zip Code", type: "text", name: "zipCode" },
    { label: "Date of Birth", type: "date", name: "dateOfBirth" },
    {
      label: "Social Security Number",
      type: "text",
      name: "socialSecurityNumber",
    },
    { label: "Email Address", type: "email", name: "email" },
    { label: "Phone Number", type: "tel", name: "phone" },
    { label: "Govt / State issued ID", type: "select", name: "documentType" },
    { label: "Document Id", type: "text", name: "documentId" },
    { label: "Document Country", type: "select", name: "documentCountry" },
    { label: "Document State", type: "select", name: "documentState" },
  ],
  "Controlling Officer": [
    { label: "First Name", type: "text", name: "firstName" },
    { label: "Last Name", type: "text", name: "lastName" },
    { label: "Address", type: "text", name: "address" },
    { label: "City", type: "text", name: "city" },
    { label: "State", type: "select", name: "state" },
    { label: "Zip Code", type: "text", name: "zipCode" },
    { label: "Date of Birth", type: "date", name: "dateOfBirth" },
    {
      label: "Social Security Number",
      type: "text",
      name: "socialSecurityNumber",
    },
    { label: "Email Address", type: "email", name: "email" },
    { label: "Phone Number", type: "tel", name: "phone" },
    { label: "Govt / State issued ID", type: "select", name: "documentType" },
    { label: "Document Id", type: "text", name: "documentId" },
    { label: "Document Country", type: "select", name: "documentCountry" },
    { label: "Document State", type: "select", name: "documentState" },
  ],
  "Beneficial Owner": [
    { label: "First Name", type: "text", name: "firstName" },
    { label: "Last Name", type: "text", name: "lastName" },
    { label: "Address", type: "text", name: "address" },
    { label: "City", type: "text", name: "city" },
    { label: "State", type: "select", name: "state" },
    { label: "Zip Code", type: "text", name: "zipCode" },
    { label: "Date of Birth", type: "date", name: "dateOfBirth" },
    {
      label: "Social Security Number",
      type: "text",
      name: "socialSecurityNumber",
    },
    { label: "Email Address", type: "email", name: "email" },
    { label: "Phone Number", type: "tel", name: "phone" },
    {
      label: "Percent Ownership of Business",
      type: "number",
      name: "percentOwnership",
    },
    { label: "Govt / State issued ID", type: "select", name: "documentType" },
    { label: "Document Id", type: "text", name: "documentId" },
    { label: "Document Country", type: "select", name: "documentCountry" },
    { label: "Document State", type: "select", name: "documentState" },
  ],
};

export const validateField = (value: any, fieldName: string, benificialPercentage: any, documentType?: string): string => {
  console.log(documentType, "documentType")
  switch (fieldName) {
    case "firstName":
    case "lastName":
      return /^[A-Za-z\s-'`]+$/.test(value) ? "" : `${fieldName} is required.`;
    case "address":
    case "city":
    case "state":
    case "documentType":
      return value === "" ? `${fieldName} is required.` : "";
      // case "documentId":
      //   if (value === "") return "Document ID is required.";
      //   if (documentType === "id_passport" || documentType === "id_passport_card") {
      //     const docIdLength = value.replace(/[^a-zA-Z0-9]/g, '').length;
      //     if (docIdLength < 6 || docIdLength > 9) {
      //       return `Document ID for ${documentType === "id_passport" ? "Passport" : "Passport Card"} must be between 6 and 9 characters`;
      //     }
      //   }
      return "";
    case "zipCode":
      return /^\d{5}(-\d{4})?$/.test(value) ? "" : "ZIP Code must be in the format 00000 or 00000-0000.";
    case "dateOfBirth":
      if (value === "" || value === 'Invalid date') {
        return "Date of Birth is required.";
      }

      const birthDate = new Date(value);
      const currentDate = new Date();
      const age = currentDate.getFullYear() - birthDate.getFullYear();
      const monthDifference = currentDate.getMonth() - birthDate.getMonth();

      if (age < 18 || (age === 18 && monthDifference < 0)) {
        return "You must be at least 18 years old.";
      }

      return "";
    case "socialSecurityNumber":
      const cleanedSSN = value?.replace(/-/g, "");
      const area = cleanedSSN.substring(0, 3);
      const group = cleanedSSN.substring(3, 5);
      const serial = cleanedSSN.substring(5, 9);
      if (area === "000" || area === "666" || area.startsWith("9")) {
        return "SSN is not valid.";
      }

      if (group === "00") {
        return "SSN is not valid.";
      }

      if (serial === "0000") {
        return "SSN is not valid.";
      }

      if (!/^\d{9}$/.test(cleanedSSN)) {
        return "Social Security Number must be 9 digits.";
      }
      return ""; // SSN is valid

    case "email":
      return /\S+@\S+\.\S+/.test(value) ? "" : "Email Address is invalid.";
    case "phone":
      // Accept any format as long as there are 10 digits
      const phoneDigits = (value || "").replace(/\D/g, "");
      return phoneDigits.length === 10
        ? ""
        : "Phone Number must contain 10 digits.";
    case "percentOwnership":
      return value >= benificialPercentage && value <= 100
        ? ""
        : `Ownership percentage must be ${benificialPercentage === 100 ? '100' : 'between 50 and 100'}`;
    default:
      return "";
  }
};

export const normalizeUserData = (data: UserData,SignupEmail: string): 
NormalizedUserData => ({
  investorId:data.investorId,
  firstName: data.firstName,
  lastName: data.lastName,
  email: data.email,
  phone: formatPhoneNumber(data.phone),
  userName: `${capitalize(data.firstName)} ${capitalize(data.lastName)}`,
  birthDate: moment(data.dateOfBirth).format("YYYY-MM-DD"),
  deliveryLine: data.address,
  deliveryLine2: data?.addressLine2 || "",
  city: capitalize(data.city),
  state: data.state || "", // Assume a default empty string for state
  country: "US",
  zipCode: formatZipCode(data.zipCode),
  idNumber: data.socialSecurityNumber.replace(/\D/g, ""),
  userType: "individual",
  SignupEmail: SignupEmail,
  documentState: data?.documentState || undefined,
  documentCountry: data?.documentCountry || undefined,
  documentId: data?.documentId || undefined,
  documentType: data?.documentType || undefined,
  IsExistingUser: data?.IsExistingUser || false,
  existingInvestorId:data?.existingInvestorId || 0,
});
